import React, { Suspense, lazy, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Results from "@/components/Results";
import Planes from "@/components/Planes";
import { SagaWork } from "@/components/SagaWork";
import { Blog } from "@/components/Blog";
import VideoSlider from "@/components/VideoSlider";
import { FAQ } from "@/components/FAQ";
import InfoCard from "@/components/InfoCard";
import { EvolucionFiscal } from "@/components/EvolucionFiscal";
import Banner from "@/components/Banner";
import { useScroll } from "@/context/ScrollContext";

// Formulario con formik+yup, debajo del fold: no debe sumar su JS al
// render inicial del Hero.
const FormPruebaGratis = lazy(() => import("@/components/FormPruebaGratis"));

const LandingPage: React.FC = () => {
  const { benefitsRef, blogRef, videoSliderRef, planesRef, scrollToRef } =
    useScroll();
  const location = useLocation();

  useEffect(() => {
    const state = location.state as { scrollTo?: string } | null;
    if (!state?.scrollTo) return;

    const refMap: Record<string, React.RefObject<HTMLDivElement | null>> = {
      beneficios: benefitsRef,
      video: videoSliderRef,
      planes: planesRef,
    };

    const ref = refMap[state.scrollTo];
    if (ref) {
      setTimeout(() => scrollToRef(ref), 100);
    }
  }, []);

  return (
    <Box bg={"#F7F9FF"}>
      <Hero />

      <Box ref={benefitsRef}>
        <InfoCard />
      </Box>

      <EvolucionFiscal />

      <Box ref={videoSliderRef}>
        <VideoSlider />
      </Box>
      <SagaWork />

      <Box ref={planesRef}>
        {/* <Planes /> */}
        <Suspense fallback={<Box minH="500px" />}>
          <FormPruebaGratis />
        </Suspense>
      </Box>

      {/* <Box ref={blogRef}>
        <Blog />
      </Box> */}

      {/* <FAQ /> */}

      <Banner />
    </Box>
  );
};

export default LandingPage;
